import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import ReadLogo from "@app/analytics/assets/integrations/read_48x48.png";

import Button, { ButtonProps } from "@rui/Button";
import Link from "@rui/Link";
import { Column, Row, StackProps } from "@rui/Stack";

interface ZapTemplateProps {
  title: string;
  app: string;
  appLogo: string;
  href: string;
}

const Wrapper = styled((props: StackProps) => (
  <Row variant="apart" {...props} />
))(({ theme }) => ({
  width: "100%",
  backgroundColor: "#fff",
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
  borderRadius: "4px",
  padding: "12px",
}));

const ZapButton = styled((props: ButtonProps<typeof Link>) => (
  <Button variant="contained" component={Link} {...props} />
))(({ theme }) => ({
  backgroundColor: "#000",
  color: "#fff",
  "&:hover": {
    backgroundColor: theme.palette.transparent.black[80],
  },
}));

const TemplateLogo = styled("img")(({ theme }) => ({
  border: "0.5px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "4px",
  padding: "4px",
  width: "32px",
  height: "32px",
}));

const ZapTemplate = ({ title, app, appLogo, href }: ZapTemplateProps) => (
  <Wrapper spacing={2}>
    <Row variant="left" spacing={0.5}>
      <TemplateLogo src={ReadLogo} />
      <TemplateLogo src={appLogo} />
    </Row>
    <Column variant="left" flexGrow={1} spacing={0.5}>
      <Typography variant="bodyPrimaryMed" color="shades.neutral.600">
        {title}
      </Typography>
      <Typography variant="labelReg" color="shades.neutral.600">
        Read + {app}
      </Typography>
    </Column>
    <ZapButton href={href}>Use this Zap</ZapButton>
  </Wrapper>
);

export default ZapTemplate;
